import { AppForm } from '../../../common/forms/app.form';
import { Form, FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { Injectable } from '@angular/core';
import {
  ApplicationAppEntityApplicationRead,
  ServiceAttachmentPositionAppEntityApplicationRead
} from '../../../openapi';

@Injectable()
export class AttachmentPaymentForm extends AppForm {
  constructor() {
    super({
      payer: new FormControl(null, Validators.required),
      attachmentPositions: new FormArray([])
    });
  }

  public get attachmentPositions(): FormArray {
    return this.get('attachmentPositions') as FormArray;
  }

  public createAttachmentPositions(app: ApplicationAppEntityApplicationRead | null): void {
    this.attachmentPositions.clear();
    const positions: ServiceAttachmentPositionAppEntityApplicationRead[] = app?.service?.serviceAttachmentPositions || [];
    positions.filter(v => v.fee).forEach(position => {
      this.attachmentPositions.push(new FormGroup({
        checked: new FormControl(false),
        fee: new FormControl(position.fee?.id, [Validators.required, Validators.max(100)]),
        quantity: new FormControl(1, [Validators.required, Validators.max(100)]),
        price: new FormControl(position.fee?.price, [Validators.required])
      }));
    });
  }

  public getPositionForm(index: number): FormGroup {
    return this.attachmentPositions.at(index) as FormGroup;
  }

  public increaseQuantity(index: number): void {
    const f: FormGroup = this.getPositionForm(index);
    const quantityControl: FormControl = f.get('quantity') as FormControl;
    quantityControl.setValue(quantityControl.value + 1);
  }

  public decreaseQuantity(index: number): void {
    const f: FormGroup = this.getPositionForm(index);
    const quantityControl: FormControl = f.get('quantity') as FormControl;
    if (quantityControl.value > 1) {
      quantityControl.setValue(quantityControl.value - 1);
    }
  }

  public getQuantity(index$: number): FormControl {
    return this.getPositionForm(index$).get('quantity') as FormControl;
  }

  public get totalAmount(): number {
    const v: { checked: boolean, quantity: number, price: number }[] = this.attachmentPositions.value;
    let result = 0;
    v.filter(v => v.checked).forEach((value) => {
      result = result + (value.price * value.quantity);
    });
    return result;
  }

}
